import { useLocation } from "react-router-dom";

export function useGetQueryParams() {
	const query = new URLSearchParams(useLocation().search);
	const obj = [...query.entries()].reduce(
		(main, [key, value]) => {
			main[key] = value;
			return main;
		},
		{} as Record<string, string>,
	);
	return obj;
}
